/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { EXPENSE_STATUSES_OPTIONS } from 'domain/shared/expense';

const ExpenseStatusField = (props: FieldProps) => {
  return <EnumField options={EXPENSE_STATUSES_OPTIONS} {...props} />;
};

export default ExpenseStatusField;
